import { render, staticRenderFns } from "./OrdenesDomicilioComponent.vue?vue&type=template&id=19256c1e&scoped=true"
import script from "./OrdenesDomicilioComponent.vue?vue&type=script&lang=js"
export * from "./OrdenesDomicilioComponent.vue?vue&type=script&lang=js"
import style0 from "./OrdenesDomicilioComponent.vue?vue&type=style&index=0&id=19256c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19256c1e",
  null
  
)

export default component.exports